"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Tab, Tabs, useTheme } from "@mui/material";
import React from "react";
import { selectCallstackIsReady } from "#/features/callstack/model/callstackSlice";
import { VIEW_LABEL_KEYS } from "#/features/playground/constants/playgroundViewLabels";
import { useMobilePlaygroundView } from "#/features/playground/hooks/useMobilePlaygroundView";
import { isPlaygroundView, PLAYGROUND_VIEWS } from "#/features/playground/model/playgroundView";
import { useI18nContext } from "#/shared/hooks";
import { glassOverlaySx } from "#/shared/ui/styles/glassOverlayStyles";
import { useAppSelector } from "#/store/hooks";
const NAV_BAR_HEIGHT = 38;
/** Matches the nav shell’s top corners (`borderRadius` on the outer `Box`). */
const NAV_BAR_TOP_CORNER_RADIUS_PX = 12;
export const MOBILE_PHASE_NAV_HEIGHT = NAV_BAR_HEIGHT;
export const MobilePhaseNavBar: React.FC = () => {
  const $ = _c(23);
  const {
    LL
  } = useI18nContext();
  const theme = useTheme();
  const {
    currentView,
    hasProjectSlug,
    goToBrowse,
    goToCode,
    goToResults
  } = useMobilePlaygroundView();
  const hasResults = useAppSelector(selectCallstackIsReady);
  let t0;
  if ($[0] !== goToBrowse || $[1] !== goToCode || $[2] !== goToResults) {
    t0 = (_, raw) => {
      if (!isPlaygroundView(raw)) {
        return;
      }
      if (raw === "browse") {
        goToBrowse();
      } else {
        if (raw === "code") {
          goToCode();
        } else {
          goToResults();
        }
      }
    };
    $[0] = goToBrowse;
    $[1] = goToCode;
    $[2] = goToResults;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleChange = t0;
  let t1;
  if ($[4] !== theme) {
    t1 = glassOverlaySx(theme);
    $[4] = theme;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      height: `calc(${NAV_BAR_HEIGHT}px + env(safe-area-inset-bottom, 0px))`,
      paddingBottom: "env(safe-area-inset-bottom)",
      zIndex: 1100,
      display: "flex",
      alignItems: "stretch",
      borderRadius: `${NAV_BAR_TOP_CORNER_RADIUS_PX}px ${NAV_BAR_TOP_CORNER_RADIUS_PX}px 0 0`,
      ...t1,
      border: "none"
    };
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== LL) {
    t3 = LL.PLAYGROUND();
    $[8] = LL;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      minHeight: NAV_BAR_HEIGHT,
      width: "100%",
      "& .MuiTabs-flexContainer": {
        alignItems: "stretch",
        minHeight: NAV_BAR_HEIGHT
      },
      "& .MuiTab-root": {
        minHeight: NAV_BAR_HEIGHT,
        py: 0,
        px: 0.5,
        fontSize: "0.7rem",
        fontWeight: 600,
        textTransform: "none",
        letterSpacing: "0.02em",
        lineHeight: 1.2,
        overflow: "hidden"
      },
      "& .MuiTab-root:first-of-type": {
        borderTopLeftRadius: `${NAV_BAR_TOP_CORNER_RADIUS_PX}px`
      },
      "& .MuiTab-root:last-of-type": {
        borderTopRightRadius: `${NAV_BAR_TOP_CORNER_RADIUS_PX}px`
      },
      "& .MuiTabs-indicator": {
        height: 2,
        borderRadius: "2px 2px 0 0"
      }
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== LL || $[12] !== hasProjectSlug || $[13] !== hasResults) {
    t5 = PLAYGROUND_VIEWS.map(view => <Tab key={view} value={view} label={LL[VIEW_LABEL_KEYS[view]]()} disabled={view === "code" ? !hasProjectSlug : view === "results" ? !hasResults : false} />);
    $[11] = LL;
    $[12] = hasProjectSlug;
    $[13] = hasResults;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== currentView || $[16] !== handleChange || $[17] !== t3 || $[18] !== t5) {
    t6 = <Tabs value={currentView} onChange={handleChange} variant="fullWidth" aria-label={t3} sx={t4}>{t5}</Tabs>;
    $[15] = currentView;
    $[16] = handleChange;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t2 || $[21] !== t6) {
    t7 = <Box component="nav" sx={t2}>{t6}</Box>;
    $[20] = t2;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};